import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PermissionGuard from './PermissionGuard';

const ProtectedRoute = ({ 
  children, 
  requiredRoles = [], 
  requiredPermissions = [],
  requiredModule = null,
  redirectTo = '/login' 
}) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Chargement...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Vérifier les rôles, permissions ou module
  if (requiredModule || requiredRoles.length > 0 || requiredPermissions.length > 0) {
    return (
      <PermissionGuard 
        requiredRoles={requiredRoles} 
        requiredPermissions={requiredPermissions}
        requiredModule={requiredModule}
      >
        {children}
      </PermissionGuard>
    );
  }

  return children;
};

export default ProtectedRoute;

